<style>
	#portal {
		width: 100vw;
		height: 100vh;
		overflow: scroll;
		}
	#graph-container {
		position: relative;
		margin: 0 auto;
		width: 906px;
		height: 1132px;
		background-color: #fff;
		}
		#graph-container::before,
		#graph-container::after {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			content: '';
			opacity: 0;
			transition: opacity .4s ease;
			z-index: 1;
			}
			#graph-container.highlight-1::before {
				background-image: url('/img/position1/1st-degree-connectors.svg'), url('/img/position1/2nd-degree-connectors.svg');
				background-position: 82px 209px, 32px 54px;
				background-repeat: no-repeat;
				opacity: 1;
				transition-delay: .2s;
				}
			#graph-container.highlight-2::after {
				background-image: url('/img/position2/1st-degree-connectors.svg');
				background-position: 459px 290px;
				background-repeat: no-repeat;
				opacity: 1;
				transition-delay: .2s;
				}
	button {
		position: fixed;
		z-index: 100;
		}
</style>

<script lang="ts">	
	import Breed from './Breed.svelte';
	import Card from './Card.svelte';

	enum Visibility {
		Active = 'active',
		Primary = 'primary',
		Secondary = 'secondary',
		Hidden = 'hidden'
	}
	
	type BreedInfo = {
		slug: string;
		name: string;
		position1: {
			left: number;
			top: number;
			visibility: Visibility;
		},
		position2: {
			left: number;
			top: number;
			visibility: Visibility;
		}
	}
	
	const breeds: Array<BreedInfo> = [
		{
			slug: 'alaskan-malamute',
			name: 'Alaskan Malamute',
			position1: {
				left: 399,
				top: 438,
				visibility: Visibility.Active
			},
			position2: {
				left: 399,
				top: 438,
				visibility: Visibility.Primary
			}
		},
		{
			slug: 'siberian-husky',
			name: 'Siberian Husky',
			position1: {
				left: 605,
				top: 471,
				visibility: Visibility.Primary
			},
			position2: {
				left: 605,
				top: 471,
				visibility: Visibility.Active
			}
		},
		{
			slug: 'alaskan-husky',
			name: 'Alaskan Husky',
			position1: {
				left: 399,
				top: 226,
				visibility: Visibility.Primary
			},
			position2: {
				left: 718,
				top: 242,
				visibility: Visibility.Primary
			}
		},
		{
			slug: 'chinook',
			name: 'Chinook',
			position1: {
				left: 117,
				top: 159,
				visibility: Visibility.Primary
			},
			position2: {
				left: 117,
				top: 159,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'canadian-eskimo-dog',
			name: 'Canadian Eskimo Dog',
			position1: {
				left: 22,
				top: 479,
				visibility: Visibility.Primary
			},
			position2: {
				left: 22,
				top: 479,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'northern-inuit-dog',
			name: 'Northern Inuit Dog',
			position1: {
				left: 279,
				top: 524,
				visibility: Visibility.Primary
			},
			position2: {
				left: 511,
				top: 314,
				visibility: Visibility.Primary
			}
		},
		{
			slug: 'alaskan-klee-kai',
			name: 'Alaskan Klee Kai',
			position1: {
				left: 313,
				top: 816,
				visibility: Visibility.Primary
			},
			position2: {
				left: 581,
				top: 633,
				visibility: Visibility.Primary
			}
		},
		{
			slug: 'greenland-dog',
			name: 'Greenland Dog',
			position1: {
				left: 581,
				top: 712,
				visibility: Visibility.Primary
			},
			position2: {
				left: 581,
				top: 712,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'carolina-dog',
			name: 'Carolina Dog',
			position1: {
				left: 631,
				top: 260,
				visibility: Visibility.Primary
			},
			position2: {
				left: 631,
				top: 260,
				visibility: Visibility.Hidden
			}
		},
		// BEGIN SECONDARY
		{
			slug: 'german-shepherd-dog',
			name: 'German Shepherd Dog',
			position1: {
				left: 0,
				top: 140,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 0,
				top: 140,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'czechoslovakian-wolfdog',
			name: 'Czechoslovakian Wolfdog',
			position1: {
				left: 64,
				top: 0,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 64,
				top: 0,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'saarloos-wolfdog',
			name: 'Saarloos Wolfdog',
			position1: {
				left: 203,
				top: 20,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 203,
				top: 20,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'belgian-sheepdog',
			name: 'Belgian Sheepdog',
			position1: {
				left: 383,
				top: 42,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 383,
				top: 42,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'german-shepherd-dog',
			name: 'German Shepherd Dog',
			position1: {
				left: 591,
				top: 105,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 591,
				top: 105,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'czechoslovakian-wolfdog',
			name: 'Czechoslovakian Wolfdog',
			position1: {
				left: 734,
				top: 105,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 734,
				top: 105,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'saarloos-wolfdog',
			name: 'Saarloos Wolfdog',
			position1: {
				left: 786,
				top: 283,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 786,
				top: 283,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'american-indian-dog',
			name: 'American Indian Dog',
			position1: {
				left: 778,
				top: 501,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 778,
				top: 501,
				visibility: Visibility.Primary
			}
		},
		{
			slug: 'american-eskimo-dog',
			name: 'American Eskimo Dog',
			position1: {
				left: 310,
				top: 992,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 310,
				top: 992,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'samoyed',
			name: 'Samoyed',
			position1: {
				left: 153,
				top: 961,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 153,
				top: 961,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'german-shepherd-dog',
			name: 'German Shepherd Dog',
			position1: {
				left: 175,
				top: 543,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 175,
				top: 543,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'czechoslovakian-wolfdog',
			name: 'Czechoslovakian Wolfdog',
			position1: {
				left: 175,
				top: 683,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 175,
				top: 683,
				visibility: Visibility.Hidden
			}
		},
		{
			slug: 'white-swiss-shepherd',
			name: 'White Swiss Shepherd',
			position1: {
				left: 309,
				top: 661,
				visibility: Visibility.Secondary
			},
			position2: {
				left: 309,
				top: 661,
				visibility: Visibility.Hidden
			}
		}
	]

	let highlight: number = 1;
	let infoOpen: boolean = false;

	function toggleHighlight() {
		if (highlight == 1) {
			highlight = 2;
		}
		else {
			highlight = 1;
		}
	}

	function handleScroll(e) {
		const top = e.target.scrollTop;
		const left = e. target.scrollLeft;
		console.log(left, top);

		// Highlight Alaskan Malamute
		if (
			(top > 90)
			&& (top < 230)
			&& (left > 248)
			&& (left < 310)
		) {
			highlight = 1;
			// console.log('Alaskan Malamute');
		}
		
		// Highlight Siberian Husky
		if (
			(top > 140)
			&& (top < 240)
			&& (left > 440)
			&& (left < 520)
		) {
			highlight = 2;
			// console.log ('Siberian Husky');
		}

		
	}

	// Open the overlay
	function handleClick() {
		infoOpen = !infoOpen;
	}

</script>

<main>
	<div id="portal" on:scroll="{handleScroll}" on:click="{handleClick}">
		<!-- <button on:click={toggleHighlight}>Toggle Highlighted Breed</button> -->
		<div id="graph-container" class="highlight-{highlight}">
			{#each breeds as breed}
				<Breed breed="{breed}" {highlight} />
			{/each}
		</div>
	</div>

	<Card open="{infoOpen}" />
</main>